import { Component, TemplateRef, HostListener } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from './user.service';
import { faEllipsisV, faEarthAsia, faSearch, faBars, faEdit, faL } from '@fortawesome/free-solid-svg-icons';
import { ToastrService } from 'ngx-toastr';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.scss'],
})
export class UserComponent {
    faEllipsisV = faEllipsisV;
    firstname: string = ''; // Bind to username input
    lastname: string = ''; // Bind to lastname input
    email: string = ''; // bind to email input
    gender: string = '';
    usergroup: string = '';
    // userrole: string = '';
    isFirstTime: boolean = true;
    showMenu = false;
    emailError: string = '';
    users: any;
    userGroupList: Array<any> = [];
    userGroupAllList: Array<any> = [];
    userRole: string = '';
    usersData: any;
    search: string = ''; // Search query
    limit: number = 10; // Items per page
    offset: number = 0; // Offset (for pagination)
    totalItems: number = 0; // Total number of items (to calculate total pages)
    currentPage: number = 1;
    clientIds: any = [];
    dropdown1Data: Array<any> = [];
    dropdown2Data: Array<any> = [];
    selectedOption1: any = null;
    selectedOption2: any = null;
    userGroupName: Array<string> = [];
    clientName: Array<string> = [];
    firstResult: number = 0;
    isLoading: boolean = true;
    order: string = '';
    isChanged: boolean = false;
    loading = false;

    ngOnInit(): void {
        this.loadUsers();
        this.loadDropdownData();
    }
    constructor(
        private modalService: NgbModal,
        private userService: UserService,
        private toastrService: ToastrService,
    ) {}

    // Method to open the login modal
    openUserModal(content: any): void {
        this.firstname = '';
        this.usergroup = '';
        this.lastname = '';
        this.email = '';
        this.gender = '';
        this.userRole = '';
        this.modalService.open(content, { size: 'sm', windowClass: 'custom-modal-class-user', backdrop: 'static', keyboard: false });
    }
    // userRole:this.userrole
    onSubmit(): void {
        this.loading = true;
        if (this.firstname && this.usergroup && this.lastname && this.email && this.gender) {
            const userData = { firstName: this.firstname, lastName: this.lastname, emailId: this.email, gender: this.gender, userGroup: this.usergroup, userRole: this.userRole };
            this.userService.createUser(userData).subscribe({
                next: (response) => {
                    this.loading = false; // Stop loading on error
                    console.log('user created:', response);
                    this.toastrService.success(response.message);

                    this.modalService.dismissAll();
                    this.currentPage = 1;
                    this.selectedUserGroupItems = [];
                    this.selectedClientItems = [];
                    this.searchClientName = '';
                    this.offset = 0;
                    this.loadUsers();
                    // Reload the clients after creation
                },
                error: (err) => {
                    this.loading = false; // Stop loading on error
                    this.toastrService.error(err.error.developerMessage);
                    console.error('Error creating client:', err);
                },
            });
        } else {
            this.loading = false; // Stop loading if form validation fails
        }
    }

    onFieldChange() {
        this.isChanged = true; // Flag as changed if any field is modified
    }

    onUpdateSubmit(): void {
        const strNewJson = JSON.stringify(this.usersData);
        const strOldJson = JSON.stringify(this.oldUserData);
        if (strNewJson === strOldJson) {
            this.modalService.dismissAll();
            return;
        }
        if (this.usersData.firstName && this.usersData.userGroupLabel && this.usersData.lastName && this.usersData.emailId) {
            const userData = {
                firstName: this.usersData.firstName,
                lastName: this.usersData.lastName,
                emailId: this.usersData.emailId,
                gender: this.usersData.gender,
                role: this.usersData.role,
                userGroupName: this.usersData.userGroupName,
            };
            this.userService.updateUser(userData).subscribe({
                next: (response) => {
                    console.log('user created:', response);
                    this.toastrService.success(response.message);
                    // this.loadUsers();
                    this.modalService.dismissAll();
                    // Reload the clients after creation
                    this.loadUsers();
                },
                error: (err) => {
                    this.toastrService.error(err.error.developerMessage);
                    console.error('Error creating client:', err);
                },
            });
        }
    }

    isValidUserForm: boolean = true;
    isValidUserName: boolean = false;
    isValidUserMsg: string = '';
    userid: number = 0;

    // verifyEmail() {
    //     // Clear previous error messages
    //     this.emailError = '';
    //     this.isValidUserMsg = '';

    //     // Check if the email field is empty (required validation)

    //     if (this.email.trim() === '') {
    //         this.isValidUserForm = false;
    //         this.isValidUserName = false;
    //         this.emailError = 'Email is required.';
    //         return; // Stop further execution if the field is empty
    //     }

    //     // Proceed with backend check if email is not empty

    //     if (this.userid === 0) {
    //         this.isValidUserForm = true;
    //         this.isValidUserName = false;
    //         this.isValidUserMsg = '';
    //         this.isLoading = true;

    //         this.validateEmail();

    //         if (this.emailError !== '') {
    //             return;
    //         }

    //         console.log('this.clientName');
    //         console.log(this.email);

    //         this.userService.getVerifyisUserExist(this.email).subscribe({
    //             next: (response) => {
    //                 this.isLoading = false;
    //                 this.isValidUserName = response.exists;
    //                 this.isValidUserMsg = 'This email already exists.';
    //                 if (this.isValidUserName) {
    //                     this.emailError = ''; // Clear the email error if the email is valid
    //                 }
    //                 if (!this.isValidUserName) {
    //                     this.isValidUserForm = false;
    //                 }
    //                 console.log('Client created:', response);
    //                 // Optionally reload clients after creation
    //             },
    //             error: (err) => {
    //                 console.error('Error verifying email:', err);
    //                 // Handle any other error from the backend, such as network issues
    //                 this.emailError = 'An error occurred while verifying the email.';
    //             },
    //         });
    //     }
    // }

    verifyEmail() {
        // Clear previous error messages
        this.emailError = '';
        this.isValidUserMsg = '';

        // Check if the email field is empty (required validation)
        if (this.email.trim() === '') {
            this.isValidUserForm = false;
            this.isValidUserName = false;
            this.emailError = 'Email is required.';
            return; // Stop further execution if the field is empty
        }

        // Proceed with backend check if email is not empty
        if (this.userid === 0) {
            this.isValidUserForm = true;
            this.isValidUserName = false;
            this.isValidUserMsg = '';
            this.isLoading = true;

            // Call the validateEmail method for additional validation if needed
            this.validateEmail();

            // Prevent API call if validation fails
            if (this.emailError !== '') {
                this.isLoading = false;
                return;
            }

            // Make POST API call to check if email exists
            this.userService.getVerifyisUserExist(this.email).subscribe({
                next: (response) => {
                    this.isLoading = false;

                    // Handle API response: assume the API response contains an `exists` field
                    this.isValidUserName = response.exists;

                    if (this.isValidUserName) {
                        this.isValidUserForm = true;
                        this.isValidUserMsg = 'This email already exists.';
                        this.emailError = ''; // Clear error message if email is valid
                    } else {
                        this.isValidUserForm = false;
                        // this.isValidUserMsg = 'This email does not exist in the system.';
                    }
                },
                error: (err) => {
                    this.isLoading = false;
                    console.error('Error verifying email:', err);
                    this.emailError = 'An error occurred while verifying the email.';
                },
            });
        }
    }

    // Fetch all clients
    loadUsers(): void {
        console.log('this.selectedUserGroupItems are', this.selectedUserGroupItems);
        this.isLoading = true;
        const userGroupAry: any = this.selectedUserGroupItems.map((item: any) => item.name);
        const clientAry: any = this.selectedClientItems.map((item: any) => item.name);
        const userList = {
            search: this.searchClientName,
            limit: this.limit,
            offset: this.offset,
            userGroupName: userGroupAry,
            clientName: clientAry,
            //firstResult: 0,
        };
        console.log('the final payload is', userList);
        this.userService.getUser(userList).subscribe({
            next: (response) => {
                this.users = response.users || []; // Assuming response has a 'users' array
                this.totalItems = response.totalCount;
                this.currentPage = Math.floor(this.offset / this.limit) + 1;
            },
            error: (err) => {
                console.error('Error fetching users:', err);
            },
            complete: () => {
                this.isFirstTime = false;
                this.isLoading = false; // Stop loading
            },
        });
    }

    onButtonClick(event: Event) {
        this.showMenu = !this.showMenu;
        event.stopPropagation(); // Prevent clicking outside from closing the menu
    }

    // Handle the delete action
    deleteItem() {
        // Perform your delete operation here
        console.log('Delete clicked');
        this.showMenu = false; // Hide menu after action
    }
    clientList: any = [];

    selectedClientCountText = '#count# Client(s) Selected';
    selectedClientBlankText = 'No Client Selected';
    selectedClientItems: Array<any> = []; // Preselected item(s)

    onSelectionClientChange(selected: Array<any>) {
        this.selectedClientItems = selected;
        this.search = this.searchClientName;
        console.log('Selected items:', selected);
        this.limit = 10; // Items per page
        this.offset = 0;
        // this.users = [];
        this.loadUsers();
        this.loadUsergroup();
    }
    onSelectionUserGroupChange(selected: Array<any>) {
        this.selectedUserGroupItems = selected;
        this.limit = 10; // Items per page
        this.offset = 0;
        this.search = this.searchClientName;
        //    this.users = [];
        console.log('Selected items:', selected);
        this.loadUsers();
    }

    loadClient(): void {
        const clientParam = { query: '', limit: 0, offset: 0, order: 'ASC', sortBy: 'ClientName' };
        this.userService.getClients(clientParam).subscribe({
            next: (data) => {
                this.clientList = data.clients || [];
            },
            error: (err) => {
                console.error('Error fetching users:', err);
            },
        });
    }
    selectedUserGroupCountText = '#count# User Group(s) Selected';
    selectedUserGroupBlankText = 'No User Group Selected';
    selectedUserGroupItems: any = []; // Preselected item(s)

    userRoleList: any = [];
    loadAllUserRole(): void {
        this.userService.getUserRoles().subscribe({
            next: (data: any) => {
                this.userRoleList = data || [];
            },
            error: (err: any) => {
                console.error('Error fetching users:', err);
            },
        });
    }
    loadAllUsergroup(): void {
        const usergroupData = { query: '', limit: 0, offset: 0, clientIds: [], order: 'DESC', sortBy: 'UserGroupName' };
        this.userService.getUsergroup(usergroupData).subscribe({
            next: (data) => {
                this.userGroupAllList = data.userGroups || [];
            },
            error: (err) => {
                console.error('Error fetching users:', err);
            },
        });
    }
    loadUsergroup(): void {
        const clientIdArys: any = this.selectedClientItems.map((item: any) => item.id);
        const usergroupData = { query: '', limit: 0, offset: 0, clientIds: clientIdArys };
        this.userService.getUsergroup(usergroupData).subscribe({
            next: (data) => {
                this.userGroupList = data.userGroups || [];
            },
            error: (err) => {
                console.error('Error fetching users:', err);
            },
        });
    }

    validateEmail(): void {
        // Regular expression for basic email validation
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        if (!this.email) {
            this.emailError = 'Email is required';
        } else if (!emailRegex.test(this.email)) {
            this.emailError = 'Enter a valid email address';
        } else {
            this.emailError = ''; // No error if email is valid
        }
    }

    oldUserData: any = {};
    openEditModal(user: any, modal: TemplateRef<any>) {
        console.log('openEditModal >>');
        console.log(user);
        this.usersData = { ...user }; // Copy the user data into userData for editing
        this.oldUserData = { ...user };
        console.log('openEditModal >> this.usersData');
        console.log(this.usersData);
        this.modalService.open(modal, { size: 'sm', windowClass: 'custom-modal-class-user', backdrop: 'static', keyboard: false });
        this.activePopupIndex = null;
    }

    // Function to open the delete confirmation modal
    openDeleteModal(user: any, deleteModal: TemplateRef<any>) {
        this.usersData = { ...user }; // Store the user data if needed to be used in deletion
        this.modalService.open(deleteModal, { size: 'sm', windowClass: 'custom-modal-class-user', backdrop: 'static', keyboard: false });
    }

    confirmDelete(modal: any) {
        // Implement the delete logic here, such as calling an API to delete the user
        console.log('User deleted:', this.usersData);

        // Close the modal after confirmation
        modal.close();
    }

    cancelDelete(modal: any) {
        modal.dismiss('Cancel click');
    }

    loadDropdownData(): void {
        this.loadClient();
        this.loadUsergroup();
        this.loadAllUsergroup();
        this.loadAllUserRole();
    }

    onDropdown2Change(): void {
        console.log('Selected option in Dropdown 1:', this.selectedOption2);
    }

    activePopupIndex: number | null = null;
    activeAccessList: number | null = null;

    togglePopup(index: number, event: Event): void {
        event.stopPropagation();
        if (this.activePopupIndex === index) {
            // Close the "Actions" popup
            this.activePopupIndex = null;
        } else {
            // Open the "Actions" popup and close the "Access" popup
            this.activePopupIndex = index;
            this.activeAccessList = null;
        }
    }
    // Close all popups when clicking outside
    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent): void {
        this.activePopupIndex = null;
        this.activeAccessList = null;
    }

    pageNumber = {
        page: 1,
    };
    totalPages: any;
    itemsPerPage = 10; // Items per page
    // Get start and end item indices for the current page
    get startItem(): number {
        return (this.currentPage - 1) * this.itemsPerPage + 1;
    }

    onPageChanged(event: any) {
        this.pageNumber = event;
        this.offset = (this.pageNumber.page - 1) * this.itemsPerPage;
        this.limit = this.pageNumber.page === this.totalPages ? this.totalItems - this.offset : this.itemsPerPage;
        this.search = this.searchClientName;
        this.loadUsers();
    }

    get endItem(): number {
        const endItem = this.currentPage * this.itemsPerPage;
        return endItem > this.totalItems ? this.totalItems : endItem;
    }

    // Navigate to the previous page
    prevPage(): void {
        if (this.currentPage > 1) {
            this.currentPage--;
        }
    }

    // Navigate to the next page
    nextPage(): void {
        if (this.currentPage < this.totalPages) {
            this.currentPage++;
        }
    }
    searchClientName: string = '';
    userSearchList() {
        this.currentPage = 1;
        if (this.searchClientName != '') this.SearchList();
    }
    SearchList() {
        this.limit = 10; // Items per page
        this.offset = 0;
        //  this.users = [];
        const userGroupAry: any = this.selectedUserGroupItems.map((item: any) => item.name);
        const clientAry: any = this.selectedClientItems.map((item: any) => item.name);
        const userList = {
            search: this.searchClientName,
            limit: this.limit,
            offset: this.offset,
            userGroupName: userGroupAry,
            clientName: clientAry,
            //firstResult: 0,
        };
        this.userService.getUser(userList).subscribe({
            next: (response) => {
                this.users = response.users || []; // Assuming response has a 'users' array
                this.totalItems = response.totalCount;
                this.currentPage = Math.floor(this.offset / this.limit) + 1;
            },
            error: (err) => {
                console.error('Error fetching users:', err);
            },
        });
    }

    clearSearch() {
        this.searchClientName = ''; // Clear the search input
        this.currentPage = 1;
        this.SearchList();
    }

    onSearchTextChange() {
        if (this.searchClientName == '') {
            this.SearchList();
        }
    }

    restrictInput(event: KeyboardEvent): void {
        const allowedCharacters = /^[a-zA-Z0-9-_ ]*$/;
        const inputChar = event.key;

        if (!allowedCharacters.test(inputChar)) {
            event.preventDefault(); // Block the keypress
        }
    }
}
